import { useState } from "react";
import {
    createUserWithEmailAndPassword,
    sendEmailVerification,
} from "firebase/auth";
import { auth, db } from "../Firebase";
import { ref, set } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const SignUp = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [sign, setSign] = useState(false);
    const navigate = useNavigate();
    const handleSignUp = (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            toast.warn("Passwords do not match");
            return;
        }
        if (password.length < 8) {
            toast.warn("Password must be at least 8 characters long.");
            return;
        }
        setSign(true);
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                set(ref(db, user.uid), {
                    id: user.uid,
                    username: name,
                    height: 0,
                    weight: 0,
                    diet: "",
                    disease: "[]",
                    preferedDiet: "[]",
                    preferedWorkOut: "[]",
                    gender: "",
                });
                sendEmailVerification(user);
                //add toastify to display email verification link is sent
                toast.info("Email verification link has been sent.");
                setSign(false);
                auth.signOut();
                navigate("/login"); // Redirect to login page after sign up
            })
            .catch((error) => {
                switch (error.code) {
                    case "auth/email-already-in-use":
                        toast.warn("Email is already in use.");
                        break;
                    case "auth/invalid-email":
                        toast.warn("Invalid email address.");
                        break;
                    case "auth/weak-password":
                        toast.warn(
                            "Password is too weak. Please choose a stronger password."
                        );
                        break;
                    case "auth/missing-email":
                        toast.warn("Email is required.");
                        break;
                    default:
                        toast.error("An error occurred. Please try again.");
                }
                setSign(false);
            });
    };
    return (
        <div className="page">
            <h1 className="page_h">CREATE ACCOUNT</h1>
            <input
                type="text"
                placeholder="Enter Name"
                className="info"
                value={name}
                onChange={(e) => {
                    setName(e.target.value);
                }}
            />
            <input
                type="email"
                placeholder="Enter Email"
                className="info"
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                }}
            />
            <input
                type="password"
                placeholder="Enter Password"
                className="info"
                value={password}
                onChange={(e) => {
                    setPassword(e.target.value);
                }}
            />
            <input
                type="password"
                placeholder="Confirm Password"
                className="info"
                value={confirmPassword}
                onChange={(e) => {
                    setConfirmPassword(e.target.value);
                }}
            />

            <button
                className="btn"
                disabled={sign}
                onClick={(e) => handleSignUp(e)}>
                {!sign ? "SIGN UP" : "Signing up... "}
            </button>
        </div>
    );
};
export default SignUp;
